import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    deleteContact: 'Delete contact',
    modalTitle: 'Edit a contact',
    saveChanges: 'Save changes',
    successMessage: 'Your client’s contact {0} was successfully updated.',
    successTitle: 'Your client’s contact was updated',
  },
  fr: {
    deleteContact: 'Supprimer le contact',
    modalTitle: 'Modifier un contact',
    saveChanges: 'Enregistrer les modifications',
    successMessage: 'Le contact de votre client {0} a bien été modifié',
    successTitle: 'Le contact de votre client a été modifié',
  },
} as const);

export default locales;
